// Wat een actiekaart zegt, zonder React: vitest draait het zonder DOM.

import { ActionRun } from "./types";

/** "7.40" → "€ 7,40"; zonder bedrag leeg. */
export const euro = (amount?: string | null) =>
  amount ? `€ ${Number(amount).toFixed(2).replace(".", ",")}` : "";

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

/** De percelen waar een betaalde opvraging over gaat, bij naam. */
export const quotedParcels = (run: ActionRun): string[] =>
  (run.arguments.parcels ?? []).map((parcel: { name: string }) => parcel.name);

/**
 * De uitkomst van een eigendomsopvraging in één regel: wat er binnenkwam, wat
 * het kostte, en wat er niet lukte. Het werkelijke bedrag, niet het
 * geoffreerde: een perceel dat intussen al geleverd was, kost niets.
 */
export function ownershipSummary(result: Record<string, any>): string {
  const fetched = result.fetched?.length ?? 0;
  const skipped = result.skipped?.length ?? 0;
  const failed = result.errors?.length ?? 0;
  const parts = [`${plural(fetched, "perceel", "percelen")} opgevraagd (${euro(result.cost_eur)})`];
  if (skipped) parts.push(`${skipped} overgeslagen`);
  if (failed) parts.push(`${failed} mislukt`);
  return parts.join(", ");
}

/** Of de kaart nog een bevestigknop toont. */
export const awaitsConfirmation = (run: ActionRun) =>
  run.paid && (run.status === "pending" || run.status === "failed");
